
//src/assets/scripts/top/page.js
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Swiper from 'swiper';

import { Autoplay,Parallax,Scrollbar, Mousewheel, Navigation, Pagination, EffectFade } from "swiper/modules";

//import BeerSlider from "beerslider";


gsap.registerPlugin(ScrollTrigger);



export default class PageJS {
    constructor(common) {
        this.common = common;
    }

    init() {
        this._btnStyle();
        this._secBeforeAfter();
        this._secFeatures();
        this._secSliderSwiper();
        this._secHowtoSwiper();
        this._secStory();
        this._acc();
        this._imgPararax();


        this.common.init();//common.jsはここでinitさせる
    }

    _btnStyle() {
        const mm = gsap.matchMedia();
        // PC
        mm.add("(min-width: 768px)", () => {

            document.querySelectorAll(".cv_btn_style a").forEach((btn) => {
                const arrowWrap = btn.querySelector(".arrow");
                const a1 = btn.querySelector(".arrow1");
                const a2 = btn.querySelector(".arrow2");
                if (!arrowWrap || !a1 || !a2) return;

                const onEnter = () => {
                    gsap.to(arrowWrap, { scale: 1.05, duration: 0.25, overwrite: true });

                    // 1枚目：右上に抜ける（= 右へ、上へ）
                    gsap.to(a1, {
                        "--ax": "120%",
                        "--ay": "-200%",
                        duration: 0.35,
                        overwrite: true,
                    });

                    // 2枚目：左下から中央へ（待機 → 中央）
                    gsap.to(a2, {
                        "--ax": "-50%",
                        "--ay": "-50%",
                        duration: 0.35,
                        delay: 0.12,
                        overwrite: true,
                    });
                };

                const onLeave = () => {
                    gsap.to(arrowWrap, { scale: 1, duration: 0.25, overwrite: true });

                    // 戻す：1枚目を中央へ
                    gsap.to(a1, {
                        "--ax": "-50%",
                        "--ay": "-50%",
                        duration: 0.25,
                        overwrite: true,
                    });

                    // 2枚目を左下待機へ
                    gsap.to(a2, {
                        "--ax": "-200%",
                        "--ay": "100%",
                        duration: 0.25,
                        overwrite: true,
                    });
                };

                btn.addEventListener("mouseenter", onEnter);
                btn.addEventListener("mouseleave", onLeave);
            });
        });
    }

    _secBeforeAfter_BK() {
        window.addEventListener("load", () => {
            new BeerSlider(document.getElementById("beer1"), {
                start: 50, // 初期位置(%)
            });
        });
    }

    _secBeforeAfter_BK2() {
        const areas = document.querySelectorAll(".js-before-after");
        if (!areas.length) return;

        areas.forEach((area) => {
            const reveal = area.querySelector(".beer-reveal");
            const handle = area.querySelector(".beer-handle");

            if (!reveal || !handle) return;

            let isDragging = false;

            const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

            const updateByClientX = (clientX) => {
                const rect = area.getBoundingClientRect();
                const x = clamp(clientX - rect.left, 0, rect.width);
                const percent = rect.width ? (x / rect.width) * 100 : 50;

                reveal.style.width = `${percent}%`;
                handle.style.left = `${percent}%`;
            };

            const startDrag = (clientX) => {
                isDragging = true;
                area.classList.add("is-dragging");
                updateByClientX(clientX);
            };

            const moveDrag = (clientX) => {
                if (!isDragging) return;
                updateByClientX(clientX);
            };

            const endDrag = () => {
                isDragging = false;
                area.classList.remove("is-dragging");
            };

            // pointer events
            area.addEventListener("pointerdown", (e) => {
                startDrag(e.clientX);
            });

            window.addEventListener("pointermove", (e) => {
                moveDrag(e.clientX);
            });

            window.addEventListener("pointerup", endDrag);
            window.addEventListener("pointercancel", endDrag);

            // touch fallback
            area.addEventListener(
                "touchstart",
                (e) => {
                    const touch = e.touches[0];
                    if (!touch) return;
                    startDrag(touch.clientX);
                },
                { passive: true }
            );

            window.addEventListener(
                "touchmove",
                (e) => {
                    const touch = e.touches[0];
                    if (!touch) return;
                    moveDrag(touch.clientX);
                },
                { passive: true }
            );

            window.addEventListener("touchend", endDrag);
            window.addEventListener("touchcancel", endDrag);

            // clickでも移動できるように
            area.addEventListener("click", (e) => {
                updateByClientX(e.clientX);
            });

            // 初期値
            reveal.style.width = "50%";
            handle.style.left = "50%";
        });
    }
    _secBeforeAfter_BK3() {
        const areas = document.querySelectorAll(".js-before-after");
        if (!areas.length) return;

        areas.forEach((area) => {
            const reveal = area.querySelector(".beer-reveal");
            const handle = area.querySelector(".beer-handle");

            if (!reveal || !handle) return;

            let isDragging = false;

            const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

            const syncState = (percent) => {
                if (percent <= 1) {
                    area.classList.add("is-after-only");
                    area.classList.remove("is-before-only");
                } else if (percent >= 99) {
                    area.classList.add("is-before-only");
                    area.classList.remove("is-after-only");
                } else {
                    area.classList.remove("is-before-only", "is-after-only");
                }
            };

            const updateByClientX = (clientX) => {
                const rect = area.getBoundingClientRect();
                const x = clamp(clientX - rect.left, 0, rect.width);
                const percent = rect.width ? (x / rect.width) * 100 : 50;

                reveal.style.width = `${percent}%`;
                handle.style.left = `${percent}%`;
                syncState(percent);
            };

            const startDrag = (clientX) => {
                isDragging = true;
                area.classList.add("is-dragging");
                updateByClientX(clientX);
            };

            const moveDrag = (clientX) => {
                if (!isDragging) return;
                updateByClientX(clientX);
            };

            const endDrag = () => {
                isDragging = false;
                area.classList.remove("is-dragging");
            };

            area.addEventListener("pointerdown", (e) => {
                startDrag(e.clientX);
            });

            window.addEventListener("pointermove", (e) => {
                moveDrag(e.clientX);
            });

            window.addEventListener("pointerup", endDrag);
            window.addEventListener("pointercancel", endDrag);

            area.addEventListener(
                "touchstart",
                (e) => {
                    const touch = e.touches[0];
                    if (!touch) return;
                    startDrag(touch.clientX);
                },
                { passive: true }
            );

            window.addEventListener(
                "touchmove",
                (e) => {
                    const touch = e.touches[0];
                    if (!touch) return;
                    moveDrag(touch.clientX);
                },
                { passive: true }
            );

            window.addEventListener("touchend", endDrag);
            window.addEventListener("touchcancel", endDrag);

            area.addEventListener("click", (e) => {
                updateByClientX(e.clientX);
            });

            reveal.style.width = "50%";
            handle.style.left = "50%";
            syncState(50);
        });
    }
    _secBeforeAfter() {
        const areas = document.querySelectorAll(".js-before-after");
        if (!areas.length) return;

        areas.forEach((area) => {
            const reveal = area.querySelector(".beer-reveal");
            const handle = area.querySelector(".beer-handle");

            if (!reveal || !handle) return;

            let isDragging = false;

            const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

            const updateByClientX = (clientX) => {
                const rect = area.getBoundingClientRect();
                const x = clamp(clientX - rect.left, 0, rect.width);
                const percent = rect.width ? (x / rect.width) * 100 : 50;

                reveal.style.width = `${percent}%`;
                handle.style.left = `${percent}%`;
            };

            const startDrag = (clientX) => {
                isDragging = true;
                area.classList.add("is-dragging");
                updateByClientX(clientX);
            };

            const moveDrag = (clientX) => {
                if (!isDragging) return;
                updateByClientX(clientX);
            };

            const endDrag = () => {
                isDragging = false;
                area.classList.remove("is-dragging");
            };

            area.addEventListener("pointerdown", (e) => {
                startDrag(e.clientX);
            });

            window.addEventListener("pointermove", (e) => {
                moveDrag(e.clientX);
            });

            window.addEventListener("pointerup", endDrag);
            window.addEventListener("pointercancel", endDrag);

            area.addEventListener("touchstart", (e) => {
                const touch = e.touches[0];
                if (!touch) return;
                startDrag(touch.clientX);
            }, { passive: true });

            window.addEventListener("touchmove", (e) => {
                const touch = e.touches[0];
                if (!touch) return;
                moveDrag(touch.clientX);
            }, { passive: true });

            window.addEventListener("touchend", endDrag);
            window.addEventListener("touchcancel", endDrag);

            area.addEventListener("click", (e) => {
                updateByClientX(e.clientX);
            });

            reveal.style.width = "50%";
            handle.style.left = "50%";
        });
    }

    

    _secFeatures() {
        const area = document.querySelector("#Features_area");
        const txt = area?.querySelector(".txt_area");
        const img = area?.querySelector(".img_area");
        if (!area || !txt || !img) return;

        const mm = gsap.matchMedia();

    

        // PC
        mm.add("(min-width: 768px)", () => {

            const st = ScrollTrigger.create({
                trigger: img,
                start: "top top",
                end: "bottom 60%",
                //end: () => "+=" + (window.innerHeight * 2),
                endTrigger: txt,
                pin: true,
                scrub: true, // 進捗を滑らかに取得するため
                //markers: true,
                onUpdate: (self) => {
                    if (self.progress >= 0.5) {
                        img.classList.add("on");
                    } else {
                        img.classList.remove("on");
                    }
                },
            });

            return () => st.kill();
        });

        // SP
        mm.add("(max-width: 767px)", () => {
            const st = ScrollTrigger.create({
                trigger: img,
                start: "top top",
                end: "bottom 30%",
                //end: () => "+=" + (window.innerHeight * 2),
                endTrigger: txt,
                pin: true,
                scrub: true, // 進捗を滑らかに取得するため
                //markers: true,
                onUpdate: (self) => {
                    if (self.progress >= 0.5) {
                        img.classList.add("on");
                    } else {
                        img.classList.remove("on");
                    }
                },
            });

            return () => st.kill();
        });
    }



    _secSliderSwiper() {
        const el = document.querySelector("#Slider_area .swiper1");
        const el2 = document.querySelector("#Slider_area .swiper2");
        if (!el) return;
        new Swiper(el, {
            modules: [Autoplay, Parallax],
            loop: true, // ループ
            parallax: true, // パララックス
            allowTouchMove: false, // マウスでのスワイプ禁止
            speed: 1500, // 速度
            slidesPerView: 1,
            autoplay: {
                //reverseDirection: true, // 逆再生
                reverseDirection: false, // 逆再生
                delay: 3000, // 3秒遅らせる
            },
        });
        new Swiper(el2, {
            modules: [Autoplay, Parallax],
            loop: true, // ループ
            parallax: true, // パララックス
            allowTouchMove: false, // マウスでのスワイプ禁止
            speed: 1500, // 速度
            slidesPerView: 1,
            autoplay: {
                reverseDirection: false, // 逆再生
                delay: 3000, // 3秒遅らせる
            },
        });
    }

    _secHowtoSwiper_BK() {
        const el1 = document.querySelector(".howto_swiper");
        const el2 = document.querySelector(".howto_txt_swiper");
        if (!el1 || !el2) return;

        // テキスト（フェード）
        const swiper2 = new Swiper(el2, {
            modules: [Navigation, EffectFade],
            effect: "fade",
            fadeEffect: { crossFade: true },
            slidesPerView: 1,
            speed: 600,            // フェードは少し短めが気持ちいい
            allowTouchMove: false, // テキスト側スワイプ無効にするなら
            navigation: {
                nextEl: ".howto_txt_swiper-button-next",
                prevEl: ".howto_txt_swiper-button-prev",
            },
        });

        // 画像（スライド）
        const swiper1 = new Swiper(el1, {
            modules: [Navigation, Pagination],
            slidesPerView: "auto",
            speed: 1000,
            navigation: {
                nextEl: ".howto_swiper-button-next",
                prevEl: ".howto_swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
                formatFractionCurrent: (n) => (n < 10 ? "0" + n : n),
                formatFractionTotal: (n) => (n < 10 ? "0" + n : n),
            },
            on: {
                slideChange() {
                    // 画像が変わったらテキストをフェードで追従
                    swiper2.slideTo(this.activeIndex);
                },
            },
        });

        // 「まえ/つぎ」(テキスト側) を押したら画像も動かしたいなら双方向に
        const syncBack = () => swiper1.slideTo(swiper2.activeIndex);
        swiper2.on("slideChange", syncBack);
    }

    _secHowtoSwiper_BK2() {
        const el1 = document.querySelector(".howto_swiper");
        const el2 = document.querySelector(".howto_txt_swiper");
        const area = document.querySelector("#Howto_area");
        if (!el1 || !el2 || !area) return;

        const swiper2 = new Swiper(el2, {
            modules: [Navigation, EffectFade],
            effect: "fade",
            fadeEffect: { crossFade: true },
            slidesPerView: 1,
            speed: 600,
            allowTouchMove: false,
        });

        const swiper1 = new Swiper(el1, {
            modules: [Navigation, Pagination],
            slidesPerView: "auto",
            speed: 1000,
            navigation: {
                nextEl: ".howto_swiper-button-next",
                prevEl: ".howto_swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
                formatFractionCurrent: (n) => (n < 10 ? "0" + n : n),
                formatFractionTotal: (n) => (n < 10 ? "0" + n : n),
            },
            on: {
                slideChange() {
                    if (swiper2.activeIndex !== this.activeIndex) {
                        swiper2.slideTo(this.activeIndex);
                    }
                },
            },
        });

        swiper2.on("slideChange", () => {
            if (swiper1.activeIndex !== swiper2.activeIndex) {
                swiper1.slideTo(swiper2.activeIndex);
            }
        });

        const resetHowto = () => {
            swiper1.slideTo(0, 0);
            swiper2.slideTo(0, 0);
        };

        // 初期状態
        resetHowto();

        // 他メソッドから使えるよう保持
        this.howtoSwiper = swiper1;
        this.howtoTxtSwiper = swiper2;

        // Howto に入るたび先頭へ戻す
        ScrollTrigger.create({
            trigger: area,
            start: "top 80%",
            onEnter: resetHowto,
            onEnterBack: resetHowto,
        });
    }
    _secHowtoSwiper() {
        const el1 = document.querySelector(".howto_swiper");
        const el2 = document.querySelector(".howto_txt_swiper");
        const area = document.querySelector("#Howto_area");
        if (!el1 || !el2 || !area) return;

        const getVideos = () => Array.from(el1.querySelectorAll("video"));

        const stopAllVideos = () => {
            getVideos().forEach((video) => {
                video.pause();
                video.currentTime = 0;
            });
        };

        const playActiveVideo = (swiper) => {
            const slides = swiper.slides;
            const activeSlide = slides[swiper.activeIndex];
            if (!activeSlide) return;

            stopAllVideos();

            const video = activeSlide.querySelector("video");
            if (!video) return;

            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") {
                playPromise.catch(() => { });
            }
        };

        const swiper2 = new Swiper(el2, {
            modules: [Navigation, EffectFade],
            effect: "fade",
            fadeEffect: { crossFade: true },
            slidesPerView: 1,
            speed: 600,
            allowTouchMove: false,
        });

        const swiper1 = new Swiper(el1, {
            modules: [Navigation, Pagination],
            slidesPerView: "auto",
            speed: 1000,
            navigation: {
                nextEl: ".howto_swiper-button-next",
                prevEl: ".howto_swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
                formatFractionCurrent: (n) => (n < 10 ? "0" + n : n),
                formatFractionTotal: (n) => (n < 10 ? "0" + n : n),
            },
            on: {
                init() {
                    playActiveVideo(this);
                },
                slideChange() {
                    if (swiper2.activeIndex !== this.activeIndex) {
                        swiper2.slideTo(this.activeIndex);
                    }
                },
                slideChangeTransitionEnd() {
                    playActiveVideo(this);
                },
            },
        });

        swiper2.on("slideChange", () => {
            if (swiper1.activeIndex !== swiper2.activeIndex) {
                swiper1.slideTo(swiper2.activeIndex);
            }
        });

        const resetHowto = () => {
            swiper1.slideTo(0, 0);
            swiper2.slideTo(0, 0);
            playActiveVideo(swiper1);
        };

        resetHowto();

        this.howtoSwiper = swiper1;
        this.howtoTxtSwiper = swiper2;

        ScrollTrigger.create({
            trigger: area,
            start: "top 80%",
            onEnter: resetHowto,
            onEnterBack: resetHowto,
        });
    }


    _secStory() {
        const mm = gsap.matchMedia();

        //PCのみ
        mm.add("(min-width: 737px)", () => {
            const area = document.querySelector("#Story_area");
            if (!area) return;

            const txt = area.querySelector(".txt_area");
            const li1 = txt?.querySelector("li.story01");
            const li2 = txt?.querySelector("li.story02");
            const bar1 = li1?.querySelector(".progress span");
            const bar2 = li2?.querySelector(".progress span");
            if (!txt || !li1 || !li2 || !bar1 || !bar2) return;

            // PC画像（big / small）
            const imgBig = area.querySelector(".img_area.big.pc");
            const imgSmall = area.querySelector(".img_area.small.pc");
            const big1 = imgBig?.querySelector("li.story01");
            const big2 = imgBig?.querySelector("li.story02");
            const small1 = imgSmall?.querySelector("li.story01");
            const small2 = imgSmall?.querySelector("li.story02");

            const group1 = [li1, big1, small1].filter(Boolean);
            const group2 = [li2, big2, small2].filter(Boolean);

            // 初期化
            gsap.set([bar1, bar2], { scaleX: 0, transformOrigin: "left center" });
            gsap.set(group1, { opacity: 1 });
            gsap.set(group2, { opacity: 0 });

            const tl = gsap.timeline({
                defaults: { ease: "none" },
                scrollTrigger: {
                    trigger: area,
                    start: "top top",
                    end: () => "+=" + window.innerHeight * 2,
                    pin: true,
                    scrub: true,
                    invalidateOnRefresh: true,
                },
            });

            tl.to(bar1, { scaleX: 1, duration: 0.5 }, 0);
            tl.to(group1, { opacity: 0, duration: 0.06 }, 0.5);
            tl.to(group2, { opacity: 1, duration: 0.06 }, 0.5);
            tl.set(bar2, { scaleX: 0 }, 0.5);
            tl.to(bar2, { scaleX: 1, duration: 0.45 }, 0.55);

            // ✅ これを return すると、条件が外れた時に自動で kill される
            return () => {
                tl.scrollTrigger?.kill();
                tl.kill();
            };
        });
    }

    _acc() {
        const areas = document.querySelectorAll(".acc_area");
        if (!areas.length) return;

        areas.forEach((area) => {
            const btn = area.querySelector(".acc_btn");
            const content = area.querySelector(".acc_content");
            if (!btn || !content) return;

            // 初期：閉じ
            area.classList.remove("open");
            gsap.set(content, { height: 0, opacity: 0 });

            btn.addEventListener("click", (e) => {
                e.preventDefault();

                const isOpen = area.classList.contains("open");

                if (isOpen) {
                    area.classList.remove("open");
                    gsap.to(content, {
                        height: 0,
                        opacity: 0,
                        duration: 0.4,
                        ease: "power2.out",
                        overwrite: true,
                    });
                } else {
                    area.classList.add("open");

                    // いったん auto を解除して正しい scrollHeight を取る
                    gsap.set(content, { height: "auto" });
                    const h = content.scrollHeight;
                    gsap.set(content, { height: 0 });

                    gsap.to(content, {
                        height: h,
                        opacity: 1,
                        duration: 0.4,
                        ease: "power2.out",
                        overwrite: true,
                        onComplete: () => gsap.set(content, { height: "auto" }), // ←ここ重要
                    });
                }
            });
        });
    }
    _imgPararax_BK() {
        //data-parallax-strength="80"
        // 例：data-parallax を付けた画像だけ対象（HTML増やしたくないなら class でもOK）
        // <img ... data-parallax>
        const targets = gsap.utils.toArray("[data-parallax]");
        if (!targets.length) return;

        targets.forEach((img) => {
            // 画像の親を基準に動かす方が事故りにくい
            const trigger = img.closest("section, .parallax_wrap, .img_area, li") || img;

            // 画像がロード前だと計算がズレるので、ロード後にrefresh
            if (img.tagName === "IMG" && !img.complete) {
                img.addEventListener("load", () => ScrollTrigger.refresh(), { once: true });
            }

            // 強さ（px）：dataで上書き可
            const strength = parseFloat(img.getAttribute("data-parallax-strength") || "100");

            // 初期化（transform競合対策）
            gsap.set(img, { willChange: "transform" });

            gsap.to(img, {
                y: -strength,
                ease: "none",
                scrollTrigger: {
                    trigger,
                    start: "top bottom",   // 画面下に入ってきたら開始
                    end: "bottom top",     // 画面上に抜けたら終了
                    scrub: true,
                    invalidateOnRefresh: true,
                    // markers: true,
                },
            });
        });
    }

    _imgPararax() {
        const mm = gsap.matchMedia();

        // 共通：data-parallax を付けた要素を対象
        const getTargets = () => gsap.utils.toArray("[data-parallax]");

        const setup = (strengthDefault) => {
            const targets = getTargets();
            if (!targets.length) return;

            const tweens = [];

            targets.forEach((el) => {
                const trigger =
                    el.closest("section, .parallax_wrap, .img_area, li") || el;

                // dataで強さ上書き（なければデフォルト）
                const strength = parseFloat(
                    el.getAttribute("data-parallax-strength") || String(strengthDefault)
                );

                // 画像ロード前のズレ対策
                if (el.tagName === "IMG" && !el.complete) {
                    el.addEventListener("load", () => ScrollTrigger.refresh(), { once: true });
                }

                gsap.set(el, { willChange: "transform" });

                const tween = gsap.fromTo(
                    el,
                    { y: strength },
                    {
                        y: -strength,
                        ease: "none",
                        scrollTrigger: {
                            trigger,
                            start: "top bottom",
                            end: "bottom top",
                            scrub: true,
                            invalidateOnRefresh: true,
                            // markers: true,
                        },
                    }
                );

                tweens.push(tween);
            });

            // cleanup
            return () => {
                tweens.forEach((t) => {
                    t.scrollTrigger?.kill();
                    t.kill();
                });
            };
        };

        // ✅ PCのみ
        mm.add("(min-width: 768px)", () => setup(60));

        // ✅ SPのみ（必要なら有効化。SPは弱め推奨）
        //mm.add("(max-width: 767px)", () => setup(35));

        // 例：PCのみでやりたいなら上のSPブロックを消すだけでOK
    }



    


}
